import { useRef } from 'react';
import { FaqVariants } from '../../../Common/FAQS';
import { TocIcon } from '../../../Icons/toc';
import { LANG_DATA } from '../language/dataset';
import { ToCContainer } from '../styles';
import { ITOC } from '../types';

export const getTitleVariantClasses = (
  variant: keyof typeof FaqVariants
): string => {
  const classes: Record<keyof typeof FaqVariants, string> = {
    default: 'ml-2 font-semibold text-font-200 self-end',
    partner: 'ml-2 font-semibold text-font-200 self-end',
    itrGuide: 'ml-2 font-semibold text-font-200 self-end',
    calculator: 'text-s-24 mb-0 font-bold',
  };

  return classes[variant];
};

export const getWrapperVariantClasses = (
  variant: keyof typeof FaqVariants
): string => {
  const classes: Record<keyof typeof FaqVariants, string> = {
    default: 'tocHeader pb-3 pr-2 border-b-grey-300 bottom-1 border-b-xs',
    partner: 'tocHeader pb-3 pr-2 border-b-grey-300 bottom-1 border-b-xs',
    itrGuide: 'tocHeader pb-3 pr-2 border-b-grey-300 bottom-1 border-b-xs',
    calculator: 'text-s-24 font-bold text-font-500',
  };

  return classes[variant];
};
export const TableOfContent = ({
  content,
  language,
  variant = FaqVariants.default,
  showToCIcon = true,
}: ITOC): JSX.Element => {
  const myContainer = useRef(null);
  const faqVariant = variant as keyof typeof FaqVariants;

  return (
    <ToCContainer className="text-s-12 sm:hidden">
      <div ref={myContainer} id="sideTOC" className={variant}>
        <div id="TOC_side">
          <div className={getWrapperVariantClasses(faqVariant)} id="tocHeader">
            <div
              id="sideHead"
              className={`flex items-center gap-2 ${getTitleVariantClasses(
                faqVariant
              )}`}
            >
              {showToCIcon ? <TocIcon width={20} height={20} /> : null}
              <div>{LANG_DATA[language]?.sideBar.content}</div>
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: content?.outerHTML || '' }} />
        </div>
      </div>
    </ToCContainer>
  );
};
